import { useEffect, useState } from 'react'
import { format, subMonths } from 'date-fns'
import { useHistory } from 'react-router-dom'
import * as routes from '../../routes'

import { useUserContext } from '../../auth/UserProvider'
import Loader from '../../ui/views/Loader'

import RatesWrapperView from './RatesWrapper/View'
import Rates from './Rates'
import BillingView from './View'
import Invoices from './Table'
import Filters from './Filters/View'
import useInvoices from './useInvoices'

export const DATE_TYPES_MAP = {
  start: 'start',
  end: 'end',
}

// TODO: cuando sepamos cómo identificar qué tarifas corresponden a cada
// usuario, descomentar esta constante.
// NOTE: es probable que para saber cuál tiene asociadas un usuario nos digan
// un código para cada documento. Se puede añadir a cada documento dicho código
// para luego pasar al componente `AvailableRates` este array cortado hasta
// el código que tenga el usuario. Algo tipo:
// const userRateLimitCode = '<lo-que-sea>'
// const index = AVAILABLE_RATES.findIndex(rate => rate.code === userRateLimitCode)
// ...
// <AvailableRates rates={AVAILABLE_RATES.slice(0, index + 1)} {...otherProps} />
// ...
// const AVAILABLE_RATES = [
//   {
//     value: 1,
//     label: 'Tarifa Empresa Modelo 2022 (0-20)',
//     link:
//       process.env.PUBLIC_URL +
//       '/documents/billing/1 - Tarifa Empresa Modelo 2022 (0-20).pdf',
//   },
//   {
//     value: 2,
//     label: 'Tarifa Empresa Modelo 2022 (21-50)',
//     link:
//       process.env.PUBLIC_URL +
//       '/documents/billing/2 - Tarifa Empresa Modelo 2022 (21-50).pdf',
//   },
//   {
//     value: 3,
//     label: 'Tarifa Empresa Modelo 2022 (51-100)',
//     link:
//       process.env.PUBLIC_URL +
//       '/documents/billing/3 - Tarifa Empresa Modelo 2022 (51-100).pdf',
//   },
//   {
//     value: 4,
//     label: 'Tarifa Empresa Modelo 2022 (51-100)',
//     link:
//       process.env.PUBLIC_URL +
//       '/documents/billing/3 - Tarifa Empresa Modelo 2022 (51-100).pdf',
//   },
//   {
//     value: 5,
//     label: 'Tarifa Empresa Modelo 2022 (101-200)',
//     link:
//       process.env.PUBLIC_URL +
//       '/documents/billing/4 - Tarifa Empresa Modelo 2022 (101-200).pdf',
//   },
//   {
//     value: 6,
//     label: 'Tarifa Empresa Modelo 2022 (201-300)',
//     link:
//       process.env.PUBLIC_URL +
//       '/documents/billing/5 - Tarifa Empresa Modelo 2022 (201-300).pdf',
//   },
//   {
//     value: 7,
//     label: 'Tarifa Empresa Modelo 2022 (301-400)',
//     link:
//       process.env.PUBLIC_URL +
//       '/documents/billing/6 - Tarifa Empresa Modelo 2022 (301-400).pdf',
//   },
//   {
//     value: 8,
//     label: 'Tarifa Empresa Modelo 2022 (401-500)',
//     link:
//       process.env.PUBLIC_URL +
//       '/documents/billing/7 - Tarifa Empresa Modelo 2022 (401-500).pdf',
//   },
//   {
//     value: 9,
//     label: 'Tarifa Empresa Modelo 2022 (501-700)',
//     link:
//       process.env.PUBLIC_URL +
//       '/documents/billing/8 - Tarifa Empresa Modelo 2022 (501-700).pdf',
//   },
//   {
//     value: 10,
//     label: 'Tarifa Empresa Modelo 2022 (701-1000)',
//     link:
//       process.env.PUBLIC_URL +
//       '/documents/billing/9 - Tarifa Empresa Modelo 2022 (701-1000).pdf',
//   },
// ]

const Billing = () => {
  const user = useUserContext()
  const history = useHistory()

  useEffect(() => {
    if (!user.isFinancial) {
      history.push(routes.HOME.linkTo())
    }
  }, [history, user])

  const defaultClientCenterCode = user.centres[0]?.id
  const [clientCenterCode, setClientCenterCode] = useState(
    defaultClientCenterCode,
  )
  useEffect(() => {
    setClientCenterCode(defaultClientCenterCode)
  }, [defaultClientCenterCode])

  const [startDate, setStartDate] = useState(
    format(subMonths(new Date(Date.now()), 1), 'yyyy-MM-dd'),
  )
  const [endDate, setEndDate] = useState(
    format(new Date(Date.now()), 'yyyy-MM-dd'),
  )
  const invoicesQuery = useInvoices(clientCenterCode, startDate, endDate)

  const selectDate = (date, dateType) => {
    if (dateType === DATE_TYPES_MAP.start) {
      setStartDate(format(date, 'yyyy-MM-dd'))
    } else {
      setEndDate(format(date, 'yyyy-MM-dd'))
    }
  }
  
  return (
    <BillingView>
      <RatesWrapperView>
        <Rates clientCode={user.clientCode} />
        {/* TODO: por decisión del cliente, se ocultan temporalmente las
            tarifas disponibles debido a que no tenemos un modo de identificar
            cuáles son las correspondientes a cada usuario. */}
        {/* <AvailableRates
          changeRateLink={setRateLink}
          rateLink={rateLink}
          rates={AVAILABLE_RATES}
        /> */}
      </RatesWrapperView>
      <Filters
        clientCenterCode={clientCenterCode}
        clientCenterCodes={user?.centres.map(center => center.id)}
        selectClientCenterCode={setClientCenterCode}
        selectDate={selectDate}
        startDate={startDate}
        endDate={endDate}
      />

      {invoicesQuery.isLoading ? (
        <Loader />
      ) : invoicesQuery.isError ? (
        <p>Error cargando las facturas.</p>
      ) : Array.isArray(invoicesQuery.data) ? (
        <Invoices invoices={invoicesQuery.data} />
      ) : null}
    </BillingView>
  )
}

export default Billing
